import { FilterRuleDTO } from "./filterRuleDTO";

export class FilterProtocolOverrideDTO{

    public sequenceNo!: number;
    public filterRules!: FilterRuleDTO[];
    public filterOr!: boolean;

    constructor(){
        this.filterRules = new Array();
    }

    
}